import { Typography } from 'antd';

import styled from '@emotion/styled';

const { Text, Title } = Typography;

export const Heading = styled(Title)`
  && {
    margin-bottom: 0;
  }
`;

/** The metric the plan does not measure is shown, but greyed out (spec §3.2). */
export const Metric = styled.span<{ active: boolean }>`
  font-weight: ${({ active }) => (active ? 600 : 400)};
  color: ${({ active }) => (active ? 'inherit' : '#8a95ad')};
`;

export const Small = styled(Text)`
  && {
    font-size: 11px;
  }
`;

export const Track = styled.div`
  height: 3px;
  border-radius: 2px;
  background: #e8ecf3;
  overflow: hidden;
`;

export const Fill = styled.div`
  height: 100%;
`;

export const Stat = styled.div`
  flex: 1;
  min-width: 160px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 10px 14px;
  border: 1px solid #e3e8f1;
  border-radius: 10px;
`;

export const StatValue = styled.span<{ color?: string }>`
  font-size: 18px;
  font-weight: 700;
  color: ${({ color }) => color ?? 'inherit'};
`;
